import React from 'react';
import Image from 'next/image';
import { Image as DatoImage } from 'react-datocms';

export interface BlogImageProps {
  post: {
    title?: string | null;
    externalImageUrl?: string | null;
    externalImageWidth?: number | null;
    externalImageHeight?: number | null;
    coverImage?: any;
  };
  layout?: 'fill' | 'fixed' | 'intrinsic' | 'responsive';
  objectFit?: 'cover' | 'contain' | 'fill' | 'none' | 'scale-down';
  priority?: boolean;
  className?: string;
  sizes?: string;
}

export function BlogImage({
  post,
  layout,
  objectFit,
  priority,
  className,
  sizes = '(max-width: 768px) 100vw, 800px',
}: BlogImageProps) {
  const { externalImageUrl, externalImageWidth, externalImageHeight, coverImage, title } = post;

  if (externalImageUrl) {
    const isFill = layout === 'fill';
    return (
      <Image
        src={externalImageUrl}
        alt={title || ''}
        layout={layout}
        objectFit={isFill ? objectFit || 'cover' : objectFit}
        priority={priority}
        className={className}
        sizes={sizes}
        {...(!isFill && {
          width: externalImageWidth || 1600,
          height: externalImageHeight || 900,
        })}
      />
    );
  }

  if (coverImage) {
    return (
      <DatoImage
        data={coverImage}
        layout={layout as any}
        objectFit={objectFit}
        pictureClassName={className}
      />
    );
  }

  return null;
}

export default BlogImage;